<template>
    <div class="pc-wrap">
        <CompHeader />
        <div class="wrap">
            <!-- <div :class="['aside',sideClassObj,{'auto':isAuto}]">
                <CompSide @change="changeSide" @changeSideWidth="changeAsideWidth" />
            </div> -->
            <div class="mian-box">
                <div :class="[sideClassObj,'main']">
                    <router-view />
                </div>
                <CompFooter/>
            </div>
        </div>
        <CompFloating :show="show"/>
    </div>
</template>

<script>
import CompHeader from './common/header'
// import CompSide from './common/side'
import CompFooter from './common/footer'
import CompFloating from './common/floating'
export default {
    components: {
        CompHeader,
        // CompSide,
        CompFooter,
        CompFloating
    },
    data() {
        return {
            show: false,
            beginSideAnimation:false,
            closeSide:false,
            isSingle:false,
            isAuto:true
        }
    },
    computed: {
        sideClassObj(){
            let result = '';
            if(this.beginSideAnimation && !this.isAuto){
                if(this.isSingle){
                    result = this.closeSide ? 'closeSingle' : 'showAllSingle';
                }else{
                    result = this.closeSide ? 'close' : 'showAll'
                }
            }
            return result;
        }
    },
    mounted() {
        document.addEventListener('scroll', this.styleFun)
    },
    methods: {
        changeSide(val){
            this.isAuto = false;
            this.isSingle = val;
            if(!this.beginSideAnimation){
                this.beginSideAnimation = true;
            }
            if(this.beginSideAnimation){
                this.closeSide = !this.closeSide;
            }
        },
        changeAsideWidth(val){
            this.isAuto = val;
        },
        styleFun(e) {
            let top = e.target.scrollingElement.scrollTop
            if (top > 200) {
                this.show = true
            } else {
                this.show = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes close
{
    from {width:400px;}
    to {width:0px;}
}
@keyframes show
{
    from {width:0px;}
    to {width:400px;}
}
@keyframes closeSingle
{
    from {width:236px;}
    to {width:0px;}
}
@keyframes showSingle
{
    from {width:0px;}
    to {width:236px;}
}
@keyframes closeMain
{
    from {padding: 20px 20px 0 0;}
    to {padding: 20px 20px 0 20px;}
}
@keyframes showMain
{
    from {padding: 20px 20px 0 20px;}
    to {padding: 20px 20px 0 0;}
}
.pc-wrap {
    min-width: 1080px;
    min-height: 100vh;
    background: #F2F2F2;
    .wrap {
        display: flex;
        min-height: calc(100vh - 70px);
        .mian-box {
            flex: 1;
            min-height: calc(100vh - 70px);
            max-width: 100%;
        }
    }
    .aside{
        &.auto{
            width: auto;
        }
        &.close{
            animation:close 0.1s forwards;
        }
        &.showAll{
            animation:show 0.1s forwards;
        }
        &.closeSingle{
            animation:closeSingle 0.1s forwards;
        }
        &.showAllSingle{
            animation:showSingle 0.1s forwards;
        }
    }
    .main {
        flex: 1;
        min-width: 1080px;
        min-height: calc(100vh - 160px);
        padding: 20px 20px 0 0;
        background: #F2F2F2;
        &.close{
            animation:closeMain 0.1s forwards;
        }
        &.showAll{
            animation:showMain 0.1s forwards;
        }
        &.closeSingle{
            animation:closeMain 0.1s forwards;
        }
        &.showAllSingle{
            animation:showMain 0.1s forwards;
        }
        >.el-row{
            height: 100%;
        }
    }
}
</style>